module.exports = __webpack_public_path__ + "img/Me-Birthday.b88c3f9a.jpeg";